<template>
	<vue-scroll>
		<div class="page-contacts flex column scrollable only-y mb-20" id="page-contacts"
			v-show="userPermissionsFilter.preapprovetransactions" v-loading="pageLoading"
			:element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
			<div class="mt-0">
				<div>

					<el-button type="primary" icon="el-icon-plus" @click="openDialog" class="mb-4">Add New</el-button>
				</div>
			</div>

			<div>
				<h2 class="text-white">Country Services</h2>
				<div class="table-responsive">
					<table class="table" id="datatable" style="color:white;">
						<thead>
							<tr>
								<th>Country</th>
								<th>serviceName</th>
								<th v-show="userPermissionsFilter.preapprovetransactions">Action</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in usersdata" :key="item.ID">
								<td>{{ item.countryName }}</td>
								<!--<td>{{formatShortDate(item.createdOn)}}</td>-->
								<td>{{ item.serviceName }}</td>
								<td v-show="userPermissionsFilter.admin">
									<el-button type="danger" icon="el-icon-delete"
										@click="DeleteCountryService(item)"></el-button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogFormVisible"
				@close="closeDialog" :before-close="handleClose">
				<div class="form-box">
					<div class="row">
						<div class="row mt-12">
							<div class="col col-md-12">
								<span>Country</span>
								<span :class="required">*</span>
								<el-select v-model="countryServicesData.countryID" filterable clearable
									placeholder="Country" autocomplete="off" autofill="off" class="mb-10"
									style="width:100%" name="countryID" v-validate="'required'" data-vv-as="country">
									<el-option v-for="country in companyRegions" :key="country.id" :label="country.name"
										:value="country.id"></el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('countryID') }}</span>
								</transition>
							</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12">
								<span>Service Type</span>
								<span :class="required">*</span>
								<el-select v-model="countryServicesData.serviceID" filterable clearable
									placeholder="Service Type" autocomplete="off" autofill="off" class="mb-10"
									style="width:100%" name="servicetype" v-validate="'required'"
									data-vv-as="service type">
									<el-option v-for="service in serviceTypes" :key="service.id" :label="service.name"
										:value="service.id"></el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('servicetype') }}</span>
								</transition>
							</div>
						</div>
						<div class="row mt-12" v-show="userPermissionsFilter.completetransactions">
							<div class="col col-md-12">
								<el-button type="success" class="btn-group" style="width:30%" @click="CreateService">
									<i class="mdi mdi-checkbox-marked"></i><span> Create</span>
								</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>

		</div>
	</vue-scroll>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'CountryServices',
	data: function () {
		return {
			usersdata: '',
			userdata: '',
			ID: '',
			CountryName: '',
			serviceID: '',
			serviceName: '',
			countryServicesData: {
				countryID: "",
				serviceID: "",
			}
			//IdProfile = "data:image/png;base64," + response.data;
		}
	},
	computed: {
	},
	methods: {
		openDialog() {
			this.dialogFormVisible = true;
		},
		DeleteCountryService(item) {
			if (item.id) {
				this.$confirm('Are you sure to delete the service?').then(_ => {
					this.DeleteCountryServices(item.id).then(result => {
						if (result) {
							this.successMessage('Service Was Deleted Successifully.');
							this.refreshUsers();
						}
						else {
							this.errorMessage('Failed to delete country Service.');
						}
					});
				}).catch(_ => { });
			}
		},
		CreateService() {
			this.startLoader("Creating Service...");
			if (this.countryServicesData.countryID && this.countryServicesData.serviceID) {
				this.CreateCountryService(this.countryServicesData)
					.then((result) => {
						if (result.id > 0) {
							this.dialogFormVisible = false;
							this.stopLoader();
							this.successMessage('Service Was Created Successifully.');
							this.refreshUsers();
						}
						else {
							this.errorMessage("Failed to create service.");
							this.stopLoader();
						}
					}).catch((err) => {
						this.stopLoader();
						this.errorMessage("Failed to create service." + err);
					});
			}
			else {
				this.errorMessage("Missing details");
				this.stopLoader();
			}
		},
		refreshUsers() {
			this.startLoader("Getting Service for all countries...");
			this.getAllCountryTransactionServices()
				.then((result) => {
					this.usersdata = result;
					this.$nextTick(function () {
						this.initDt()
					});
					this.stopLoader();
				}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
		},
		initDt() {
			var cmp_logo = this.loggedInCompany.logo;
			$('#datatable').DataTable({
				retrieve: true,
				dom: 'Blfrtip',
				"aaSorting": [],
				buttons: [
					// {
					// 	extend : 'pdfHtml5',
					// 	title : function() {
					// 		return cmp;
					// 	},
					// 	orientation : 'landscape',
					// 	pageSize : 'A3', // You can also use "A1","A2" or "A3", most of the time "A3" works the best.
					// 	text : '<i class="fa fa-file-pdf-o"> PDF</i>',
					// 	titleAttr : 'PDF',
					// 	messageBottom: 'This report was generated By '+this.loggedInUser,

					// },
					// {
					// 	extend: 'print',
					// 	orientation: 'landscape',
					// 	pageSize: 'A3', // You can also use "A1","A2" or "A3", most of the time "A3" works the best.
					// 	customize: function (doc) {
					// 		doc.content.splice(1, 0, {
					// 			margin: [0, 0, 0, 10],
					// 			alignment: 'center',
					// 			image: cmp_logo
					// 		});
					// 	}
					// },
					// {
					// 	extend: 'csv',
					// 	//messageTop: cmp,
					// 	title : function() {
					// 		return cmp;
					// 	},
					// 	messageBottom: 'This report was generated By '+this.loggedInUser,
					// },
					// {
					// 	extend: 'excel',
					// 	title : function() {
					// 		return cmp;
					// 	},
					// 	messageBottom: 'This report was generated By '+this.loggedInUser,
					// },
				],

			});
		}
	},
	mounted() {
		//API Call
	},
	created() {
		this.refreshUsers();
		this.getOperationalCountries();
		this.getServices();
	},
	mixins: [PermissionsMixins]
}

</script>

<style>
.avatar-box {
	background: #3773e2;
	margin-bottom: 50px;
	position: relative;
}

.avatar-box img {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	position: relative;
	bottom: -50px;
	display: block;
	margin: 0 auto;
	background: white;
	border: 2px solid #3773e2;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
</style>